module.exports = __webpack_public_path__ + "img/ps-7.e9d6331f.jpg";